
























import { updateMetadata } from '@/store/api';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Tour extends Vue {
  @Prop({ default: [] }) public steps!: any[];
  private stepCallbacks: any = {
    onStop: () => {
      return this.actionCallback('stopped');
    },
    onSkip: () => {
      return this.actionCallback('skipped');
    },
    onFinish: () => {
      return this.actionCallback('completed');
    },
  };
  private labels: any = {
    buttonSkip: 'Skip',
    buttonPrevious: 'Previous',
    buttonNext: 'Next',
    buttonStop: 'Exit',
  };
  private metadata: any = null;

  private created() {
    this.$events.on('start-tour', (data: any) => {
      console.log('data', data);
      this.metadata = data.metadata;
      if (this.$route.name === data.page) {
        (this as any).$tours['myTour'].start();
      }
    });
  }

  private actionCallback(value: string) {
    if (this.metadata) {
      updateMetadata(this.metadata.id, value).then((result: any) => {
        this.metadata = null;
      });
    }
  }
}
